import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAll,
  clearResetBot,
  onGetAdditionalDocuments,
  onGetComments,
  setCertificateDetails,
  setErrorMessageBankUser,
  setLoadingBankUser,
} from "../../../../config/redux/slice/bankUserSlice";
import { pagesText } from "../../../../constants/english";
import {
  getExtension,
  transformFirstLetter,
} from "../../../../helpers/helpers";
import { getFileRequest, getRequest } from "../../../../helpers/request";
import { appApi } from "../../../../utils/endpoints/appApi";
import { CardLayout, CertificateWrapper } from "../../../components";
import CertificateDetailsComponent from "../CertificateDetailsComponent";
import StatusChangeConfirmation from "../StatusChangeConfirmation";
import {
  showCommentFormFunc,
  showStatusChangeConfirmationFunc,
  setConfirmationStatusModalText,
  setCertificateDetailsGeneral,
} from "../../../../config/redux/slice/appSlice";
import { PrintCertificateDoc } from "../../Print/PrintCertificateDoc";
import ReactToPrint from "react-to-print";
import CertificateComments from "../CertificateComments";
import { Link } from "react-router-dom";
import ApplicationDocuments from "../ApplicationDocuments";
import { CERTIFICATE_STATUS } from "../../../../constants";
import { convertDateTime } from "../../../../utils/lib";

export default function CertificateView() {
  const dispatch = useDispatch();

  const certificatePrintRef = useRef(null);
  const reasonablenessPrintRef = useRef(null);

  const {
    // bankUserLoading,
    // bankUserErrorMsg,
    // bankUserSuccessMsg,
    certificateManagement: {
      comments,
      newComment,
      certificateDetails,
      additionalDocs,
    },
  } = useSelector((state) => state.bankUser);

  const {
    // bankUserLoading,
    // bankUserErrorMsg,
    // bankUserSuccessMsg,
    isRefreshed,
    certificateManagement: {
      showStatusChangeConfirmation,
      certificateStatus,
      certificateStatusConfirmationBtnText,
    },
  } = useSelector((state) => state.app);

  const { token, userData } = useSelector((state) => state.authData);

  useEffect(() => {
    // getAllComments()
    if (isRefreshed == "") {
      getSingleCertificate();
    }
    getAdditionalDocs();
  }, []);

  const removeCommentFromHeader = (e, idValue, classValue) => {
    let element = document.getElementById(`${idValue}`);
    let elementAll = document.getElementsByClassName(`${classValue}`);
    for (let x = 0; x < elementAll.length; x++) {
      elementAll[x].style.display = "block";
    }
    if (e.currentTarget.classList.contains("collapsed")) {
      element.style.display = "none";
    }
  };

  const getAllComments = async () => {
    let id = certificateDetails?.ID;
    const res = await getRequest(
      token,
      `${appApi.getComments(id)}`,
      {},
      dispatch,
      setLoadingBankUser,
      onGetComments,
      setErrorMessageBankUser
    );
    //   if(res !== undefined && res.status < 400){
    //       setBanks(res.data.data)
    //   }
  };

  const getAdditionalDocs = async () => {
    const res = await getRequest(
      token,
      `${appApi.getAdditionalDocuments(certificateDetails.ID)}`,
      {},
      dispatch,
      "",
      onGetAdditionalDocuments,
      ""
    );
  };

  const getSingleCertificate = async () => {
    const res = await getRequest(
      token,
      `${appApi.getSingleCertificate(certificateDetails.ID)}`,
      {},
      dispatch,
      "",
      "",
      ""
    );
    if (res != undefined && res.status < 400) {
      dispatch(
        setCertificateDetailsGeneral({ details: res.data.data, modal: false })
      );
      dispatch(setCertificateDetails({ details: res.data.data, modal: false }));
    }
  };

  useEffect(() => {
    if (newComment) {
      getAllComments();
      dispatch(clearResetBot());
    }
  }, [newComment]);

  const downloadFiles = async () => {
    dispatch(clearAll({}));
    let created_at = convertDateTime(
      certificateDetails?.CREATED_AT,
      pagesText.full_date_for_download
    );
    let urls = [
      {
        url: certificateDetails?.CERTIFICATE_FILE_PATH,
        name: `certificate_${certificateDetails?.CERTIFICATE_NUMBER}_${created_at}`,
        ext: getExtension(certificateDetails?.CERTIFICATE_FILE_PATH),
      },
      {
        url: certificateDetails?.LETTER_OF_REASONABLENESS,
        name: `letter_of_reasonableness_${certificateDetails?.CERTIFICATE_NUMBER}_${created_at}`,
        ext: getExtension(certificateDetails?.LETTER_OF_REASONABLENESS),
      },
    ];
    const res = await getFileRequest(
      token,
      dispatch,
      setLoadingBankUser,
      setErrorMessageBankUser,
      "Certificates",
      urls
    );
  };

  return (
    <CertificateWrapper>
      {showStatusChangeConfirmation && (
        <StatusChangeConfirmation
          certificateID={certificateDetails?.ID}
          status={certificateStatus}
          btnText={certificateStatusConfirmationBtnText}
        />
      )}
      <CardLayout
        cardTitle={"Certificate Details"}
        cardButtons={<AddCertificateButton />}
      >
        <div className="row d-flex">
          <section className="col-lg-5 certificate-comment-container">
            <ul
              className="nav nav-underline-active-primary mb-3"
              id="pills-tab1"
              role="tablist"
            >
              <li
                onClick={() => {
                  dispatch(
                    setConfirmationStatusModalText({
                      documentType: "Certificate",
                    })
                  );
                }}
                className="nav-item"
              >
                <a
                  className="nav-link active"
                  id="pills-details-tab"
                  data-toggle="pill"
                  href="#nav-tabs-details"
                  role="tab"
                  aria-controls="nav-details"
                  aria-selected="true"
                >
                  Details
                </a>
              </li>
              <li
                onClick={() => {
                  dispatch(
                    setConfirmationStatusModalText({
                      documentType: "Certificate of Reasonableness",
                    })
                  );
                }}
                className="nav-item"
              >
                <a
                  className="nav-link"
                  id="nav-comments-tab"
                  data-toggle="pill"
                  href="#nav-tab-comments"
                  role="tab"
                  aria-controls="nav-comments"
                  aria-selected="false"
                >
                  Comments
                </a>
              </li>
            </ul>
            <div className="tab-content mt-5 mt-md-0" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-tabs-details"
                role="tabpanel"
                aria-labelledby="pills-details-tab"
              >
                <CertificateDetailsComponent
                  certificateObject={certificateDetails}
                />
              </div>

              <div
                className="tab-pane fade"
                id="nav-tab-comments"
                role="tabpanel"
                aria-labelledby="nav-comments-tab"
              >
                <CertificateComments certificateObject={certificateDetails} />
              </div>
            </div>
          </section>
          <section className="col-lg-7 certificate-img-container">
            <ul
              className="nav nav-underline-active-primary mb-3"
              id="pills-tab2"
              role="tablist"
            >
              <li
                onClick={() => {
                  dispatch(
                    setConfirmationStatusModalText({
                      documentType: "Certificate",
                    })
                  );
                }}
                className="nav-item"
              >
                <a
                  className="nav-link active"
                  id="pills-home-tab"
                  data-toggle="pill"
                  href="#nav-tabs-home2"
                  role="tab"
                  aria-controls="nav-tabs"
                  aria-selected="true"
                >
                  Certificate
                </a>
              </li>
              {/* <li onClick={()=>{dispatch(setConfirmationStatusModalText({documentType: 'Certificate of Reasonableness'}))}} className="nav-item">
                    <a className="nav-link" id="nav-profile-tab" data-toggle="pill" href="#nav-profile2" role="tab"
                      aria-controls="nav-profile" aria-selected="false">Certificate Of Reasonableness</a>
                  </li> */}
            </ul>
            <div className="tab-content mt-5 mt-md-0" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-tabs-home2"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <ApplicationDocuments
                  certificateObject={certificateDetails}
                  additionalDocs={additionalDocs}
                />
              </div>
            </div>
          </section>
        </div>
      </CardLayout>
    </CertificateWrapper>
  );
}

function AddCertificateButton() {
  const dispatch = useDispatch();

  const { token } = useSelector((state) => state.authData);
  const {
    certificateManagement: { certificateDetails, additionalDocs },
  } = useSelector((state) => state.bankUser);

  const downloadFiles = async () => {
    dispatch(clearAll({}));
    let created_at = convertDateTime(
      certificateDetails?.CREATED_AT,
      pagesText.full_date_for_download
    );
    let additionalFiles = Array.from(additionalDocs, (option) => {
      return {
        url: option.FILE_URL,
        name: `${option.FILE_NAME}_${certificateDetails?.CERTIFICATE_NUMBER}_${created_at}`,
        ext: getExtension(option.FILE_URL),
      };
    });
    let urls = [
      {
        url: certificateDetails?.CERTIFICATE_FILE_PATH,
        name: `certificate_${certificateDetails?.CERTIFICATE_NUMBER}_${created_at}`,
        ext: getExtension(certificateDetails?.CERTIFICATE_FILE_PATH),
      },
      {
        url: certificateDetails?.STAMPED_AGREEMENT,
        name: `stamped_agreement_${certificateDetails?.CERTIFICATE_NUMBER}_${created_at}`,
        ext: getExtension(certificateDetails?.STAMPED_AGREEMENT),
      },
      {
        url: certificateDetails?.COVER_LETTER,
        name: `cover_letter_${certificateDetails?.CERTIFICATE_NUMBER}_${created_at}`,
        ext: getExtension(certificateDetails?.COVER_LETTER),
      },
      ...additionalFiles,
      {
        url: certificateDetails?.CERTIFY_TRUE_COPY,
        name: `certified_true_copy_${certificateDetails?.CERTIFICATE_NUMBER}_${created_at}`,
        ext: getExtension(certificateDetails?.CERTIFY_TRUE_COPY),
      },
    ];
    const res = await getFileRequest(
      token,
      dispatch,
      setLoadingBankUser,
      setErrorMessageBankUser,
      `Application_Documents_${created_at}`,
      urls
    );
  };

  const handleConfirmDisbursement = useCallback(() => {
    dispatch(setConfirmationStatusModalText({ status: "disbursed" }));
    dispatch(
      setConfirmationStatusModalText({ btnText: "Confirm Disbursment" })
    );
    dispatch(showStatusChangeConfirmationFunc({ modal: true }));
  }, [dispatch]);

  return (
    <div
      style={{ columnGap: "1.2rem", rowGap: "0.7rem" }}
      className="d-flex pt-md-2 flex-wrap align-items-center"
    >
      {certificateDetails?.CERTIFICATE_STATUS !== CERTIFICATE_STATUS.CLOSED && (
        <div className="dropdown">
          <button
            className="btn btn-primary dropdown-toggle text-white"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-display="static"
          >
            Action
          </button>

          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            {/* <a onClick={()=> dispatch(showCommentFormFunc({modal:true}))} className="dropdown-item" href="#">Add Comment</a> */}
            <Link
              to={`/bank/certificates/${encodeURIComponent(
                certificateDetails.CERTIFICATE_NUMBER
              )}/transaction-history`}
              className="dropdown-item"
              href="#"
            >
              View Transaction History
            </Link>
            {certificateDetails?.CERTIFICATE_STATUS ===
              CERTIFICATE_STATUS.APPROVED && (
              <button
                className="dropdown-item"
                onClick={handleConfirmDisbursement}
              >
                Confirm Disbursement
              </button>
            )}
          </div>
        </div>
      )}

      {/* <button className='btn btn-primary' onClick={()=> dispatch(showCommentFormFunc({modal:true}))}>Add Comment</button> */}
      {/* <a className='btn btn-icon border-primary btn-outline open-in-new-tab' 
            style={{fontSize: '1.2rem'}} 
            title={`View ${documentType}`} rel='noreferrer' target='_blank' href={certificateDetails.CERTIFICATE_FILE_PATH}><i className='mdi mdi-open-in-new'></i></a> */}

      <button
        title="Download files"
        className="btn btn-sm btn-outline-primary"
        onClick={downloadFiles}
      >
        <i className="mdi mdi-arrow-down mr-1"></i> Download files
      </button>

      {/* <button className='btn btn-primary' onClick={()=> dispatch(showCommentFormFunc({modal:true}))}>
            {certificateDetails?.CERTIFICATE_STATUS == 'pending' ?
            'Proceed To Disburse' : certificateDetails?.CERTIFICATE_STATUS == 'proceed to disbursed' ?
            'Disburse' : ''
            }
          </button> */}
    </div>
  );
}
